import { BehaviorSubject } from 'rxjs';
import { map, share } from 'rxjs/operators';
import * as i0 from "@angular/core";
/**
 * this is a very special situation.
 * Normally we must never import from angular or nest packages in shared packages.
 * This is because it can make compilers crash with really bad error descriptions.
 * In this case, we CAN do this because
 * a) we know this shared package will only ever be imported from frontend
 * b) we need to solve a circular dependency between 2 frontend-shared packages.
 */
export let FormStateService = /*#__PURE__*/(() => {
  class FormStateService {
    constructor() {
      this.busyTasks$ = new BehaviorSubject([]);
      this.isBusy$ = this.busyTasks$.pipe(map(tasks => {
        return tasks.length > 0;
      }), share());
    }
    setFormBusy(id) {
      const newValue = [...this.busyTasks$.value, id];
      this.busyTasks$.next(newValue);
      return () => {
        this.endFormBusy(id);
      };
    }
    endFormBusy(id) {
      const newValue = [...this.busyTasks$.value];
      this.busyTasks$.next(newValue.filter(key => {
        return key !== id;
      }));
    }
    static {
      this.ɵfac = function FormStateService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FormStateService)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: FormStateService,
        factory: FormStateService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return FormStateService;
})();